import UsersApplicationForm from './component'

export default UsersApplicationForm
